import Vue from 'vue'
import VueRouter from 'vue-router'
// import Vote21 from '../views/Vote21.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    redirect: '/learning',
  },
  {
    path: '/learning',
    name: 'Learning & Study',
    // component: Vote21
    component: () => import('@/views/learning/Learning')
  },
  {
    path: '/learning/vote21',
    name: 'Vote 21',
    component: () => import('@/views/learning/vote21/Vote21')
  },
  {
    path: '/learning/vote21/map',
    name: 'D3.js on Vue.js',
    component: () => import('@/views/learning/vote21/Map')
  },
  {
    path: '/learning/dynamic-components',
    name: 'Dynamic Components',
    component: () => import('@/views/learning/dynamic-components/Index')
  }
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
